import { toFixedNumber } from "../../../../../base/utils";
import { Uniter } from "../../../../../helbest";
import styles from "./Item.module.css";

const Item = (props) => {
  const { active, onClick, id, name, price, image, working_status } = props;

  return (
    <div onClick={onClick} className={styles.Item} key={id}>
      <div className="flex items-center">
        {image && <img src={image} alt={name} loading="lazy" />}
        <div
          className={`${styles.PriceContainer} ${active ? styles.Active : ""}`}
        >
          <Uniter
            unit={price?.currency}
            className={styles.Price}
            isBold
            unit_bold
          >
            {toFixedNumber(price?.amount)}
          </Uniter>
          <span>
            {name} | {working_status}
          </span>
        </div>
      </div>
      <div
        className={`${styles.CheckboxCircleContainer} ${
          active ? styles.Active : ""
        }`}
      >
        <div
          className={`${styles.CheckboxCircle} ${active ? styles.Active : ""}`}
        />
      </div>
    </div>
  );
};

export default Item;
